import { safeGetStorageItem, safeRemoveStorageItem, safeSetStorageItem } from "./safeStorage";

const AUTH_STORAGE_KEYS = ["token", "expiration", "user", "userRole", "authToken"];

const PRESERVED_LOCAL_STORAGE_KEYS = new Set([
  "webDispatcherBuildVersion",
  "preferredAppLanguage",
  "i18nextLng",
  "locale",
]);

const COOKIE_PATHS = () => {
  const paths = new Set(["/"]);
  const parts = window.location.pathname.split("/").filter(Boolean);
  let current = "";

  parts.forEach((part) => {
    current += `/${part}`;
    paths.add(current);
  });

  return [...paths];
};

export const expireClientCookies = () => {
  if (typeof document === "undefined" || typeof window === "undefined") return;

  document.cookie
    .split(";")
    .map((cookie) => cookie.split("=")[0].trim())
    .filter(Boolean)
    .forEach((cookieName) => {
      COOKIE_PATHS().forEach((path) => {
        document.cookie = `${cookieName}=; Max-Age=0; path=${path}`;
      });
    });
};

export const clearClientSession = ({ preservePreferences = true } = {}) => {
  if (typeof window === "undefined") return;

  const preservedValues = {};

  if (preservePreferences) {
    PRESERVED_LOCAL_STORAGE_KEYS.forEach((key) => {
      const value = safeGetStorageItem(key);
      if (value !== null) preservedValues[key] = value;
    });
  }

  try {
    window.localStorage.clear();
  } catch (error) {
    console.warn("[WD storage] nelze vyčistit localStorage", error);
  }

  try {
    window.sessionStorage.clear();
  } catch (error) {
    console.warn("[WD storage] nelze vyčistit sessionStorage", error);
  }

  Object.entries(preservedValues).forEach(([key, value]) => {
    safeSetStorageItem(key, value);
  });

  expireClientCookies();
};

export const clearAuthStorage = () => {
  if (typeof window === "undefined") return;
  AUTH_STORAGE_KEYS.forEach((key) => safeRemoveStorageItem(key, { reason: "auth cleanup" }));
};

export { AUTH_STORAGE_KEYS };
